import React from "react";
import { SectionData, ComponentRenderProps } from "./index";
import { renderText } from "./index";

const SubTitle = ({ sectionData, props }: { sectionData: SectionData, props: ComponentRenderProps }): JSX.Element | null => {
    return renderText(sectionData.subTitle || "" , "subTitle", sectionData.uiCompType, props , 'h3') || null;
};

export default SubTitle;
